import { gql } from "@apollo/client";

export const DEBUG_UPDATE_COMPANY_SEATS = gql`
  mutation DebugUpdateCompanySeats($companyId: ID!, $seatsS: Int, $seatsM: Int, $seatsL: Int) {
    debugUpdateCompanySeats(companyId: $companyId, seatsS: $seatsS, seatsM: $seatsM, seatsL: $seatsL) {
      id
      seatsS
      seatsM
      seatsL
    }
  }
`; 